import {
  CopilotActions,
  CopilotName,
  CopilotMessages,
  CopilotInput,
  CopilotSupportButton,
  useCopilotSessionContext,
} from '@/features/copilot';
import { close, open, useSidebarActive } from '@/features/sidebar';
import { useAnalytics } from '@/services/analytics';
import { useCanGoBack, useSafeNavigate } from '@/services/router/safe-navigate';
import { Box, Button, Heading, Tooltip } from '@customerio/pluma-components/react';
import * as styles from './index.css';

import { Helmet } from 'react-helmet-async';
import { useMountEffect } from '@/hooks/use-mount-effect';

export default function Agent() {
  const isCopilotSidebarActive = useSidebarActive('copilot');
  const session = useCopilotSessionContext();
  const { track } = useAnalytics();
  const safeNavigate = useSafeNavigate();
  const canGoBack = useCanGoBack();

  useMountEffect(() => {
    if (isCopilotSidebarActive) {
      close();
    }
  });

  return (
    <>
      <Helmet>
        <title>Agent | Customer.io</title>
      </Helmet>
      <Box display="flex" flexDirection="column" h="full" w="full" backgroundColor="base">
        {/* Header */}
        <Box px="200" backgroundColor="base" className={styles.headerBar}>
          <Box display="flex" alignItems="center" justifyContent="space-between" py="100" className={styles.header}>
            <Box display="flex" alignItems="center" gap="100">
              {canGoBack ? (
                <Tooltip content="Exit full screen" isCustom={true}>
                  {(context) => (
                    <Button
                      variant="subtle"
                      size="sm"
                      icon="collapse"
                      isIconOnly={true}
                      onClick={() => {
                        track('aiAssistant', 'collapsedFromFullScreen', {});
                        open('copilot');
                        safeNavigate(-1);
                      }}
                      ref={context.reference.setReference}
                      {...context.reference.getReferenceProps()}
                    />
                  )}
                </Tooltip>
              ) : null}
              <Heading level="4">
                <CopilotName />
              </Heading>
            </Box>
            <Box display="flex" alignItems="center" gap="100">
              <Button
                variant="subtle"
                size="sm"
                icon="add"
                onClick={() => {
                  session.reset();
                  track('aiAssistant', 'newChatClicked', {});
                }}
              >
                New chat
              </Button>
              <CopilotSupportButton />
              <CopilotActions />
            </Box>
          </Box>
        </Box>

        {/* Chat area */}
        <Box display="flex" flexDirection="column" flexGrow="1" h="0" w="full" className={styles.fullscreenChat}>
          <CopilotMessages />
          <Box className={`${styles.contentContainer} ${styles.inputCard}`}>
            <CopilotInput />
          </Box>
        </Box>
      </Box>
    </>
  );
}
